namespace('compass.account');

compass.require('compass.demographic.PasswordWidget');

compass.account.ResetPasswordWidget = compass.defineWidget(function LoginWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(me);

	var ENTER_KEY = 13;

	var _settings = options;
	var _hasExistingPassword = !_settings.showResetForm;
	var _widgetElem;
	var _inputs = {};
	var _submitEnabled = false;
	var _passwordWidget;
	var _hasExistingPass = false;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});
	var _formatNumber = compass.util.phoneFormatter({}) || {};

	var _labels = {
		login:{
			placeholder: "Email Address",
			hint: "Enter your email address"
		},
		onpeakID:{
			placeholder:_settings.meetingInfo.officeName+" ID",
			hint:"Enter your "+_settings.meetingInfo.officeName+" ID"
		},
		passwordCode:{
			placeholder:"Activation Code",
			hint:"Enter your activation code"
		}


	};

	var _vh = new compass.util.validationHelper(_validator);

	var _sendEmailClicked = false;
	var _handleSendEmail = function(e) {
		if(!_sendEmailClicked) {
			_sendEmailClicked = true;
			_trackGAEvent('CLICK_ACTIVATION_BUTTON');
			_vh.detachHints();

	 		var errorsExist = _vh.attachHints();
	 		if(!errorsExist){
				var id = (_inputs.onpeakID && _inputs.onpeakID.val()) ? _inputs.onpeakID.val() : _settings.onpeakID;

				me.trigger(CompassEvents.SendResetPasswordEmail, {
					email: _inputs.login.val(),
					onpeakID: id,
					callback: function(success, hasPass, errorMessage){
						me.find('.resetPassErrorDiv').empty();
						if(success){
							_validator.clearFields();
							/*step 2 of reset process, create password form*/
							e.preventDefault();
							_showNewPasswordForm(hasExistingPassword = hasPass);
						}
						else{
							_trackGAEvent('DISPLAY_INVALID_ID_MESSAGE');
							jQuery('.resetPassErrorDiv').append(d.div({className:'error'},errorMessage.length ? errorMessage : 'There was a problem with resetting your password'));
							_sendEmailClicked = false;
						}
					}
				});
				return false;
			}
			else{
				// remove the previous errors
				me.find('.resetPassErrorDiv').empty();

				_sendEmailClicked = false;
				var errorString = 'Please provide an email address';
				if (!_settings.onpeakID) {
					errorString += ' and ' + _settings.meetingInfo.officeName + ' ID';
				}
				me.find('.resetPassErrorDiv').append(d.div({className:'resetMessage error'},errorString));
			}
		}
	};

	var _handleResetPW = function(e) {
		var id = _settings.onpeakID ? _settings.onpeakID : _inputs.onpeakID.val();

		var passValues = _passwordWidget.grabValues();
		var newPass = passValues.password1;

		_trackGAEvent('CLICK_LOGIN_BUTTON');

		me.trigger(CompassEvents.ResetPassword, {
			clientType: _settings.clientType,
			onpeakID: id,
			password: newPass,
			password_reset_code: _inputs.passwordCode.val(),
			meetingInfo: _settings.meetingInfo,
			errorCallback : _handleBackendResetPasswordError
		});
		return false;
	};

	var _handleBackendResetPasswordError = function(errorMessage){
		var helpMsg = _widgetElem.find('.passwordCreationHelpMsg');
		helpMsg.show();
		_trackGAEvent('DISPLAY_INVALID_CODE_MESSAGE');
	};



	var _render = this.render = function (widgetElem) {
		_widgetElem = widgetElem;
		_drawSendActivationCodeForm();
		me.find("#email-input").emailautocomplete({
			suggClass: "eac-sugg",
			domains: ["aol.com", "att.net", "bellsouth.net", "comcast.com", "comcast.net", "gmail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "qq.com", "sbcglobal.net", "yahoo.com", "ymail.com"]
		});
	};

	var _drawLoginInput = function () {

		_inputs.login = d.input({
			className: "login email-autocomplete",
			id: "email-input",
			name: "login",
			type: "email",
			autocomplete: 'off',
			'ARIA-label': 'Email Address'
		}).data("hint", _labels.login.hint);
		_validator.addFields(_inputs.login, _validator.EMAIL, { });

		var field = d.fieldLabelPair({
			className : 'loginField',
			label : _labels.login.placeholder
			}, [_inputs.login]);	

		return field;
	};

	var _drawIdHelpMsg = function() {
		if (!_settings.onpeakID) {
			var idHelpMsg = 'Your ' + _settings.meetingInfo.officeName + ' ID can be found on your confirmation email.';

			if (_settings.meetingInfo.phone) {
				idHelpMsg += ' If unsure of your ' + _settings.meetingInfo.officeName + ' ID, please contact us at ' + _formatNumber(_settings.meetingInfo.phone) + ' to request a copy of your confirmation.';
			}

			return d.div({ className : 'idHelp', role : 'complementary', 'aria-role' : 'complementary'}, idHelpMsg);
		}
	};

	var _drawPasswordCreationHelpMsg = function() {
		var passwordCreaitonHelpMsg = '';

		if (_settings.meetingInfo.phone) {
			passwordCreaitonHelpMsg += 'Having trouble? For assistance, please call ' + _formatNumber(_settings.meetingInfo.phone) + '.';
		}

		return d.div({ className : 'passwordCreationHelpMsg', role : 'complementary', 'aria-role' : 'complementary'}, passwordCreaitonHelpMsg);
	};

	var _drawIDInput = function () {
		if(!_settings.onpeakID) {
			_inputs.onpeakID = d.input({
				className: "onpeakID",
				name: "onpeakID",
				type: "text",
				autocomplete: 'off',
				'ARIA-label': _settings.meetingInfo.officeName+' ID'
			}).data("hint", _labels.onpeakID.hint);
			_validator.addFields(_inputs.onpeakID, _validator.FILLED, { });

			var field = d.fieldLabelPair({
				className : 'onpeakIDField',
				label : _labels.onpeakID.placeholder
				}, [_inputs.onpeakID]);	

			return field;
		}
	};

	var _drawPasswordCodeText = function () {
		var textString = "We just sent ";
		textString = textString +  _inputs.login.val();
		textString = textString + " an email with an activation code you'll need to reset your password and log in.";
		if(_hasExistingPass === false) {
			textString = "Hmm.. It seems like you never set a password but you'll need one to access your account online. " + textString;
		}
		var passwordCodeTextDiv = d.div(
			{className: "passwordCodeText", tabindex: -1},
			textString
			);

		return passwordCodeTextDiv;
	};

	var _drawResetPasscodeInstructionText = function(hasExistingPassword){
		var textString = "Click below to receive an email with an activation code you'll need to create your password.";
		var firstTimeDiv = {};
		if(hasExistingPassword === false) {
			firstTimeDiv = d.div({className: 'firstTimeUserNotification'}, "It looks like it is your first time logging in.");

		}

		var passwordCodeTextDiv = d.div(
			{className: "passwordCodeText", tabindex: -1},
			firstTimeDiv,
			textString
		);

		return passwordCodeTextDiv;
	};

	var _drawCreateNewPasswordInstructionText = function(hasExistingPassword){
		me.find('.passwordCodeText').empty();
		var leaveThisPageOpenDiv = d.div({className: 'leavePageOpenNotification'}, 'Leave this page open.');
		var textString = "Enter the activation code we sent you to create your own password and log in.";
		var passwordCodeTextDiv = d.div(
			{className: "passwordCodeText", tabindex: -1},
			textString
		);

		return [leaveThisPageOpenDiv, passwordCodeTextDiv];
	};

	var _drawPasswordCodeInput = function () {

		_inputs.passwordCode = d.input({
			className: "passwordCode",
			name: "passwordCode",
			type: "text",
			'ARIA-label': 'Password Code',
			'data-parsley-required': 'true'
		}).data("hint", _labels.passwordCode.hint);

		var field = d.fieldLabelPair({
			className : 'passwordCodeField',
			label : _labels.passwordCode.placeholder,
		}, [_inputs.passwordCode]);

		return field;
	};

	var _drawPasswordWidget = function(){
		passwordDiv = d.div({
			className:"passwordWidgetDiv"
		});
		_passwordWidget = new compass.demographic.PasswordWidget(passwordDiv, {
			WUID : 'passwordWidget_resetPassword',
			placeholder1 : 'Create Password',
			placeholder2 : 'Confirm Password'
		});
		return passwordDiv;
	};


	var _drawResetButton = function () {
		return d.button({ className: "reset button", role: 'button', 'ARIA-role': 'button', tabindex: 0 }, "Send Email").activate(_handleSendEmail);
	};

	var _drawNewPasswordButton = function () {
		return d.button({ className: "newPass button", role: 'button', 'ARIA-role': 'button', tabindex: 0 }, "Log In");
	};

	var _drawSendActivationCodeButton = function () {
		_trackGAEvent('DISPLAY_ACTIVATION_BUTTON');
		return d.button({ className: "reset button", role: 'button', 'ARIA-role': 'button', tabindex: 0 }, "Send Activation Code").activate(_handleSendEmail);
	};

	var _drawSkipToPasscodeCreationLink = function () {
		return d.a({
		    href: '#'
		}, "I already have a code").activate(function(event) {
		    event.preventDefault();
		    _showNewPasswordForm(hasExistingPassword = !_settings.showResetForm);
			_trackGAEvent('CLICK_ALREADY_HAVE_CODE_LINK');
		    return false;
		});
	};

	var _drawSendNewCodeLink = function () {
		_trackGAEvent('DISPLAY_SEND_NEW_CODE_LINK');
		return d.a({
		    href: '#'
		}, "Send a new code &raquo;").activate(function(event) {
			_trackGAEvent('CLICK_SEND_NEW_CODE_LINK');
		    event.preventDefault();
		    _drawSendActivationCodeForm();
		    /*_showSendActicationCodeForm(hasExistingPassword = false);*/
		    return false;
		});
	};

	var _drawNewPasswordForm = function(hasExistingPassword){
		var __form = d.form({className:'newPassForm'},
			_drawCreateNewPasswordInstructionText(hasExistingPassword = hasExistingPassword),
			_drawPasswordCodeInput(),/*activation code from email*/
			_drawPasswordWidget(), /*password and repeat password fields*/
			_drawNewPasswordButton(), /*submit button*/
			_drawSendNewCodeLink()
		);
		__form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});
		__form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_handleResetPW();
		});
		__form.parsley().on('form:error', function(e) {
			me.find('.resetPassErrorDiv').empty();
 			return;
 		});

		return __form;
	};

	var _drawSendActivationCodeForm = function(){
		_sendEmailClicked = false;
		_widgetElem.empty();
		_validator.clearFields();
		_widgetElem.append(
			d.reader( d.h2('Enter email and '+_settings.meetingInfo.officeName+' ID to send password reset email, '+_settings.meetingInfo.officeName+' ID can be found in confirmation email') ),
			d.div({className:'resetPassErrorDiv', role: 'alert', 'ARIA-role': 'alert'}),
			d.div({className:'resetDiv', role:'form', 'ARIA-role':'form'},
				_drawResetPasscodeInstructionText(hasExistingPassword = !_settings.showResetForm),
				d.div({ className : 'pwResetForm' },
					/* this section will be hidden if we the user is creating a password for the first time */
					d.div({ className : 'pwResetInputs' },
						_drawLoginInput(), /* email */
						_drawIDInput() /*onpeakid, this is hidden when user is creating a password for the first time */
					),
					d.div({ className : 'clear' })
				),
				d.div({ className : 'pwResetControls' },
					_drawSendActivationCodeButton(),
					_drawSkipToPasscodeCreationLink(),/* 'I already have a code' link */
					d.div({ className : 'clear' })
				)
			),
			_drawIdHelpMsg(),
			_drawPasswordCreationHelpMsg(),
			d.div({ className : 'clear' })
		);
		/* showResetForm is misleading; it's what we used to do. Now this boolean tells us whether we are here if the user was never setup with a password*/
		if(_settings.showResetForm) {
			/* we want to only show the send activate code button here by hiding the onpeakid field*/
			me.find('.onpeakID').hide();
		}
		me.find('.passwordCreationHelpMsg').hide(); /*hide the 'do you need help' message initially */
	};

	var _disableSendActivationForm = function(){
		me.find('.pwResetForm').hide();
		_validator.clearFields();
	};

	/* takes care of hiding the reset form and showing the password creation form correctly*/
	var _showNewPasswordForm = function(hasExistingPassword){
		_disableSendActivationForm();
		me.find('.pwResetControls').hide();
		me.find('.resetDiv').append(
			_drawNewPasswordForm(hasExistingPassword = hasExistingPassword)
		);
		me.find('.idHelp').hide();
		me.find('.passwordCreationHelpMsg').hide();
		me.find('input[placeholder], textarea[placeholder]').placeholderEnhanced();
	};

	/*convenience function for GA event tracking*/
	var _trackGAEvent = function(actionKey){
		var activationCategoryStep1 = 'Password Activation Step 1';
		var activationCategoryStep2 = 'Password Activation Step 2';
		var resetCategoryStep1 = 'Password Reset Step 1';
		var resetCategoryStep2 = 'Password Reset Step 2';
		var flow = _hasExistingPassword ? 'RESET_FLOW' : 'ACTIVATION_FLOW';
		var eventMap = {
			'ACTIVATION_FLOW':[
					{
						'actionKey': 'DISPLAY_ACTIVATION_BUTTON', 'actionObject' : {'category' : activationCategoryStep1, 'action':'Display Activation Code Button', 'label' : 'Activation Code Button'}
					},
					{
						'actionKey': 'CLICK_ACTIVATION_BUTTON', 'actionObject' : {'category' : activationCategoryStep1, 'action':'Click Activation Button', 'label' : 'Send Activation Code'}
					},
					{
						'actionKey': 'CLICK_ALREADY_HAVE_CODE_LINK', 'actionObject' : {'category' : activationCategoryStep1, 'action':'Click Already Have Code Link', 'label' : 'Already Have Code Link'}
					},
					{
						'actionKey': 'DISPLAY_SEND_NEW_CODE_LINK', 'actionObject' : {'category' : activationCategoryStep2, 'action':'Display Send New Code Link', 'label' : 'New Code Link'}
					},
					{
						'actionKey': 'CLICK_SEND_NEW_CODE_LINK', 'actionObject' : {'category' : activationCategoryStep2, 'action':'Click Send New Code Link', 'label' : 'Send New Code'}
					},
					{
						'actionKey': 'DISPLAY_INVALID_CODE_MESSAGE', 'actionObject' : {'category' : activationCategoryStep2, 'action':'Display Invalid Code Message', 'label' : 'Invalid Code'}
					},
					{
						'actionKey': 'CLICK_LOGIN_BUTTON', 'actionObject' : {'category' : activationCategoryStep2, 'action':'Click Log In Button', 'label' : 'Log In'}
					}
			],
			'RESET_FLOW':[
					{
						'actionKey': 'DISPLAY_ACTIVATION_BUTTON', 'actionObject' : {'category' : resetCategoryStep1, 'action':'Display Activation Code Button', 'label' : 'Activation Code Button'}
					},
					{
						'actionKey': 'CLICK_ACTIVATION_BUTTON', 'actionObject' : {'category' : resetCategoryStep1, 'action':'Click Activation Button', 'label' : 'Send Activation Code'}
					},
					{
						'actionKey': 'CLICK_ALREADY_HAVE_CODE_LINK', 'actionObject' : {'category' : resetCategoryStep1, 'action':'Click Already Have Code Link', 'label' : 'Already Have Code Link'}
					},
					{
						'actionKey': 'DISPLAY_INVALID_ID_MESSAGE', 'actionObject' : {'category' : resetCategoryStep1, 'action':'Display Invalid ID Message', 'label' : 'Invalid ID Message'}
					},
					{
						'actionKey': 'DISPLAY_SEND_NEW_CODE_LINK', 'actionObject' : {'category' : resetCategoryStep2, 'action':'Display Send New Code Link', 'label' : 'New Code Link'}
					},
					{
						'actionKey': 'CLICK_SEND_NEW_CODE_LINK', 'actionObject' : {'category' : resetCategoryStep2, 'action':'Click Send New Code Link', 'label' : 'Send New Code'}
					},
					{
						'actionKey': 'DISPLAY_INVALID_CODE_MESSAGE', 'actionObject' : {'category' : resetCategoryStep2, 'action':'Display Invalid Code Message', 'label' : 'Invalid Code'}
					},
					{
						'actionKey': 'CLICK_LOGIN_BUTTON', 'actionObject' : {'category' : resetCategoryStep2, 'action':'Click Log In Button', 'label' : 'Log In'}
					}
			]
		};


		var properActionElement = _.findWhere(eventMap[flow], {actionKey : actionKey});
		if(properActionElement){
			var properAction = properActionElement.actionObject.action;
			var properLabel = properActionElement.actionObject.label;
			var properCategory = properActionElement.actionObject.category;

			compass.GA.trackEvent(properCategory, properAction, properLabel);
		}
	};

	this.grabValues = function() {
		return {
			email : _inputs.login.val(),
			onpeakID : _inputs.onpeakID.val()
		};
	};

}, {
	WUID: 'defaultResetPasswordWidgetWUID',
	widgetName: 'ResetPasswordWidget',
	meetingInfo : {},
	onpeakID: null,
	clientType:null,
	showResetForm: false,
	callback: function() { document.location.reload(true);}
});

